import React, { useEffect, useState, useRef } from 'react';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import ConnectBankForm from './connectBankForm';
import Box from '@mui/material/Box';
import {
  getInputIfscValue,
  fetchIfscReq,
  getCKycRequest,
  getResetIfscCode,
} from './connectBankAction';
import { checkDigit, ifscRegex } from '../../../utils/regExp';
import { getPersonalInfoRequest } from '../PersonalInfo/personalInfoAction';
import { logFirebaseEvent } from '../firebase';
import {
  P2P_BANKING_DETAILS_BTN,
  P2P_BANKING_DETAILS_VIEW,
} from '../firebase/constant';
import { getAuthToken } from '../../../utils/localStorage';
import jwt from 'jwt-decode';
import { getCustomerDetails } from '../Auth/Login/actionLogin';
import {Typography } from '@material-ui/core';
import ProgressBar from '../../../Common/ProgressBar';

const ConnectBank = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const formikRef: any = useRef();
  // const [readOnly, setReadOnly] = useState<boolean>(false);
  // const [accountNumberAccess, setAcountNumberAccess] = useState<boolean>(false);
  // const [accountTypeAccess, setAccoutnTypeAccess] = useState<boolean>(false);
  // const [ifscAccess, setIfscAccess] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>('');
  const { accountTypeData, ifscData, connectFetchKycError, ifscError } =
    useSelector((state: any) => state.connectBank);

  const { personalInfoData, error } = useSelector(
    (state: any) => state.personalInfo
  );

  const { customerData } = useSelector((state: any) => state.login);

  useEffect(() => {
    logFirebaseEvent(P2P_BANKING_DETAILS_VIEW);
  }, []);

  useEffect(() => {
    if (personalInfoData && personalInfoData?.status) {
      if (personalInfoData?.results !== 'already completed') {
        window.location.replace(personalInfoData?.results);
      } else {
        history.push({
          pathname: '/p2p/lenderAgreement',
        });
      }
    }
    if (customerData && customerData.status && customerData?.results?.IFSC) {
      setIfscInputValue(customerData?.results?.IFSC);
      dispatch(fetchIfscReq());
    }
  }, [personalInfoData, customerData]);

  useEffect(() => {
    dispatch(getCustomerDetails(2));
    document.title = 'stashearn - connect-bank';
  }, []);

  const initialValues = {
    accountNumber: customerData?.results?.AccountNumber,
    accountType: 'Savings',
    ifscCode: customerData?.results?.IFSC,
    confirmAccountNumber: customerData?.results?.AccountNumber,
  };

  const validationSchema = () =>
    Yup.object().shape({
      accountNumber: Yup.string()
        .matches(checkDigit, 'Allow digits only')
        .min(9, 'Minimum 9 digit required')
        .max(20, 'Maximum 20 digit required')
        .required('*Required'),
      // confirmAccountNumber: Yup.string()
      //   .oneOf([Yup.ref('accountNumber'), null], 'Account number do not match')
      //   .min(9, 'Minimum 9 digit required')
      //   .max(20, 'Maximum 20 digit required')
      //   .required('*Required'),
      accountType: Yup.string().required('*Required'),
      ifscCode: Yup.string()
        .required('*Required')
        .test('fetch-ifsc', (value) => setIfscInputValue(value)),
    });

  const onSubmitHandle = (value: any) => {
    const token: any = getAuthToken();
    const decodedToken = jwt(token); // decode your token here
    logFirebaseEvent(P2P_BANKING_DETAILS_BTN);
    if (ifscData?.BRANCH) {
      dispatch(getCKycRequest(value));
      dispatch(getPersonalInfoRequest(decodedToken));
      return false;
    }
  };

  const onChangeField = () => {};

  const setIfscInputValue = (value: any) => {
    if (value !== undefined) {
      if (ifscRegex.test(value)) {
        dispatch(getInputIfscValue(value));
        setErrorMessage('');
      } else {
        setErrorMessage('Special characters are not allowed');
      }
    } else {
      setErrorMessage('');
    }
    return value;
  };

  const blurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    dispatch(fetchIfscReq());
  };

  const enterKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (formikRef?.current?.isValid) {
        onSubmitHandle(formikRef.current.values);
      }
    }
  };

  return (
    <>
      <BackgroundTheme>
      <ProgressBar 
          progress={90}
          />
        <Box sx={{ mt: 1, mb: 2 }}>
          <Typography
            variant='h1'
            className='text-blue text-center fs-25 fw-800'
          >
            You are almost done!
          </Typography>
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography
            variant='h2'
            className='text-red fs-20 fw-200 text-center'
          >
            Fill up your bank details
          </Typography>
        </Box>
        <ConnectBankForm
          initialValues={initialValues}
          onSubmitHandle={onSubmitHandle}
          validationSchema={validationSchema}
          onChangeField={onChangeField}
          ifscData={ifscData}
          blurHandler={blurHandler}
          connectFetchKycError={connectFetchKycError}
          error={error}
          accountTypeData={accountTypeData}
          errorMessage={errorMessage}
          formikRef={formikRef}
          enterKeyPress={enterKeyPress}
          ifscError={ifscError}
          // readOnly={readOnly}
          // accountNumberAccess = {accountNumberAccess}
          // accountTypeAccess = {accountTypeAccess}
          // ifscAccess = {ifscAccess}
        />
      </BackgroundTheme>
    </>
  );
};
export default ConnectBank;
